import { RefObject, useEffect } from 'react';
import { debounce } from 'lodash';

export enum HoverEventEnum {
  out = 'out',
  over = 'over'
}

const MouseHoverEvents = {
  out: ['mouseout'],
  over: ['mouseover']
};

export const useOnMouseHover = (
  ref: RefObject<HTMLElement>,
  handler: CallableFunction,
  hoverEvent: HoverEventEnum
): void => {
  const events = MouseHoverEvents[hoverEvent];

  useEffect(() => {
    const listener = debounce((event: Event) => {
      if (
        hoverEvent === HoverEventEnum.out &&
        ref.current !== event.target &&
        !ref.current?.contains(event.target as Node)
      ) {
        handler(event);
      } else if (
        hoverEvent === HoverEventEnum.over &&
        (ref.current === event.target || ref.current?.contains(event.target as Node))
      ) {
        handler(event);
      }
    }, 200);

    events.forEach(type => {
      document.addEventListener(type, listener);
    });

    return () => {
      events.forEach(type => {
        document.removeEventListener(type, listener);
      });
    };
    // TODO-FIX-TS-WARNINGS
    // eslint-disable-next-line
  }, [ref, handler, events]);
};
